import Vue from 'vue';
import Vuex from 'vuex';
import UAParser from 'ua-parser-js';

Vue.use(Vuex)

// 生成 mutations 方法
function generate(name) {
  return function (state, value) {
    state[name] = value;
  }
}

const ua = UAParser(window.navigator.userAgent);
const isWeChat = ua.browser.name === 'WeChat' ? true: false;

const options = {
	state: {
		ua: ua,
		isWeChat: isWeChat, // 是否在微信内
		preRoute: '',
		userId: '', // 投保人id
		accessToken: '',
		bankCardNo:'',//绑定的银行卡后四位
		bankBindId: 0,//绑定ID
		re_from: '',
		order_from: ''
	},

	// 操作
	actions: {},
	// 数据变更
	mutations: {}
}

// 为每个 state 字段生成对应的 mutations 方法
Object.keys(options.state).forEach((key) => {
  options.mutations[key] = generate(key);
});

export default new Vuex.Store(options);

